import * as types from './actionTypes'

export const fetchPlanning = (id) => ({
    type: types.PLANNING_FETCH,
    id
})

export const fetchPlanningSuccess = (planning) => ({
    type: types.PLANNING_FETCH_SUCCESS,
    planning
})

export const fetchPlanningFailed = () => ({
    type: types.PLANNING_FETCH_FAILED
})

export const updatePlanning = (config) => ({
    type: types.UPDATE_PLANNING,
    config
})

export const updatePlanningSuccess = (planning) => ({
    type: types.UPDATE_PLANNING_SUCCESS,
    planning
})

export const updatePlanningFailed = () => ({
    type: types.UPDATE_PLANNING_FAILED
})

export const fetchPlannngData = (id) => ({
    type: types.PLANNING_DATA_FETCH,
    id
})

export const fetchPlanningDataSuccess = (data) => ({
    type: types.PLANNING_DATA_FETCH_SUCCESS,
    data
})

export const fetchPlanningDataFailed = () => ({
    type: types.PLANNING_DATA_FETCH_FAILED
})

export const changePlanningEvent = (entity, record, planning, action) => ({
    type: types.PLANNING_EVENT_CHANGE,
    entity,
    record,
    planning,
    action
})

export const changePlanningEventSuccess = (data) => ({
    type: types.PLANNING_EVENT_CHANGE_SUCCESS,
    data
})

export const changePlanningEventFailed = () => ({
    type: types.PLANNING_EVENT_CHANGE_FAILED
})

export const setColors = (id, data) => ({
    type: types.SET_COLORS,
    id,
    data
})

export const setColorsSuccess = (planning) => ({
    type: types.SET_COLORS_SUCCESS,
    planning
})

export const setColorsFailed = () => ({
    type: types.SET_COLORS_FAILED
})

export const deletePlanning = (id) => ({
    type: types.PLANNING_DELETE,
    id
})

export const deletePlanningSuccess = (planning) => ({
    type: types.PLANNING_DELETE_SUCCESS,
    planning
})

export const deletePlanningFailed = () => ({
    type: types.PLANNING_DELETE_FAILED
})

export const resetPlanning = () => ({
    type: types.PLANNING_RESET
})